import React from 'react';
import { Link } from 'react-router-dom';
import api, { setCustomerSession } from '../api/client';
import withRouter from '../withRouter';

class SignupPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { fullName: '', email: '', phone: '', password: '', error: null, submitting: false };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { fullName, email, phone, password } = this.state;
    this.setState({ submitting: true, error: null });

    api.signup(fullName, email, password, phone)
      .then(({ token, customer }) => {
        setCustomerSession(token, customer);
        this.props.onLogin(customer);
        this.props.navigate('/');
      })
      .catch((err) => {
        this.setState({ submitting: false, error: err.response?.data?.error || 'Sign up failed' });
      });
  };

  render() {
    const { fullName, email, phone, password, error, submitting } = this.state;
    return (
      <div className="auth-page">
        <h1>Create an account</h1>
        <form onSubmit={this.handleSubmit}>
          <label>
            Full name
            <input required value={fullName} onChange={(e) => this.setState({ fullName: e.target.value })} />
          </label>
          <label>
            Email
            <input type="email" required value={email} onChange={(e) => this.setState({ email: e.target.value })} />
          </label>
          <label>
            Phone (optional)
            <input value={phone} onChange={(e) => this.setState({ phone: e.target.value })} />
          </label>
          <label>
            Password
            <input type="password" required minLength={8} value={password} onChange={(e) => this.setState({ password: e.target.value })} />
          </label>
          {error && <p className="error">{error}</p>}
          <button className="btn btn-primary" type="submit" disabled={submitting}>
            {submitting ? 'Creating account...' : 'Sign up'}
          </button>
        </form>
        <p className="auth-switch">Already have an account? <Link to="/login">Log in</Link></p>
      </div>
    );
  }
}

export default withRouter(SignupPage);
